import { useContext } from "react";
import { UserContext } from "@/contexts/UserContext";

// import {
//   useUserProfile,
//   useUserCollections,
//   useUserLooks,
//   useUserProducts,
//   useUserSubscribers,
//   useUserSubscribedTo,
//   useUpdateUser,
// } from "@/hooks/api/useUsers";
// import * as UserTypes from "@wtf/shared";

/**
 * Hook to get the current authenticated user
 * Returns the current Firebase user object, loading state, and authentication status
 */
export function useCurrentUser() {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useCurrentUser must be used within a UserProvider");
  }
  // Destructure context for clearer return values
  const { user, loading, isAuthenticated } = context;
  return { user, loading, isAuthenticated };
}

// /**
//  * Hook to get the current user's profile
//  */
// export function useCurrentUserProfile() {
//   const { user, loading: userLoading } = useCurrentUser();
//   const { data: profile, isLoading: profileLoading, error, refetch, ...rest } = useUserProfile(user?.uid);

//   return {
//     profile,
//     isLoading: userLoading || profileLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }

// /**
//  * Hook to update the current user's profile
//  */
// export function useUpdateCurrentUserProfile() {
//   const { user } = useCurrentUser();
//   const updateUserMutation = useUpdateUser();

//   const updateProfile = (data: UserTypes.UpdateUserRequest) => {
//     if (!user?.uid) return Promise.reject(new Error("User not authenticated"));
//     return updateUserMutation.mutateAsync({ id: user.uid, data });
//   };

//   return {
//     ...updateUserMutation,
//     updateProfile,
//   };
// }

// /**
//  * Hook to get collections created by the current user
//  */
// export function useCurrentUserCollections(params: { page?: number; limit?: number } = {}) {
//   const { user, loading: userLoading } = useCurrentUser();
//   const {
//     data: collections,
//     isLoading: collectionsLoading,
//     error,
//     refetch,
//     ...rest
//   } = useUserCollections(user?.uid, params);

//   return {
//     collections,
//     isLoading: userLoading || collectionsLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }

// /**
//  * Hook to get looks created by the current user
//  */
// export function useCurrentUserLooks(params: { page?: number; limit?: number } = {}) {
//   const { user, loading: userLoading } = useCurrentUser();
//   const { data: looks, isLoading: looksLoading, error, refetch, ...rest } = useUserLooks(user?.uid, params);

//   return {
//     looks,
//     isLoading: userLoading || looksLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }

// /**
//  * Hook to get products created by the current user
//  */
// export function useCurrentUserProducts(params: { page?: number; limit?: number } = {}) {
//   const { user, loading: userLoading } = useCurrentUser();
//   const { data: products, isLoading: productsLoading, error, refetch, ...rest } = useUserProducts(user?.uid, params);

//   return {
//     products,
//     isLoading: userLoading || productsLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }

// /**
//  * Hook to get users subscribed to the current user (followers)
//  */
// export function useCurrentUserSubscribers(params: { page?: number; limit?: number } = {}) {
//   const { user, loading: userLoading } = useCurrentUser();
//   const {
//     data: subscribers,
//     isLoading: subscribersLoading,
//     error,
//     refetch,
//     ...rest
//   } = useUserSubscribers(user?.uid, params);

//   return {
//     subscribers,
//     isLoading: userLoading || subscribersLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }

// /**
//  * Hook to get users that the current user is subscribed to (following)
//  */
// export function useCurrentUserSubscribedTo(params: { page?: number; limit?: number } = {}) {
//   const { user, loading: userLoading } = useCurrentUser();
//   const {
//     data: subscribedTo,
//     isLoading: subscribedToLoading,
//     error,
//     refetch,
//     ...rest
//   } = useUserSubscribedTo(user?.uid, params);

//   return {
//     subscribedTo,
//     isLoading: userLoading || subscribedToLoading,
//     error,
//     refetch,
//     ...rest,
//   };
// }
